import './BattleStatGamePad.scss';

import NP from "../../1. Core/NP";
import Label from "../../1. Core/Controls/Label/Label";
import {IBattleEvent} from "../../10. Battle/Util";
import BattleStatGamePad from "./BattleStatGamePad";
import moment = require("moment");
export default class BattleStatGamePad2 extends BattleStatGamePad {


	private _redCurrentEvents: IBattleEvent[];
	private _blueCurrentEvents: IBattleEvent[];


	constructor(props: object)
	{
		super(props);
		this._CanClickOneButton = true;
	}

	_onPauseClick()
	{
		if (this._IsPause)
		{
			this._IsPause = false;
			this._PauseLength += (new Date()).getTime() - this._PauseStarted;
			this._PauseStarted = null;
		}
		else
		{
			this._IsPause = true;
			this._PauseStarted = (new Date).getTime();
		}
	}

	setRedStartState()
	{
		this._redCurrentEvents = [];
		this._leftPadLabels.forEach(lbl => lbl.setEnabled(lbl.getData() != 'IsAnswer'));
	}

	setBlueStartState()
	{
		this._blueCurrentEvents = [];
		this._rightPadLabels.forEach(lbl => lbl.setEnabled(lbl.getData() != 'IsAnswer'));
	}

	_onGamePadClick(gamepad: Gamepad, label: Label, isRed: boolean, isButtonHold?: boolean)
	{

		let actionId = label.getRK(),
			 isAnswer = label.getData() == 'IsAnswer',
			 currentEvents = isRed ? this._redCurrentEvents : this._blueCurrentEvents;


		if (this._IsPause && actionId != 'SelectLbl')
			return this.vibrate(gamepad);

		if (actionId == 'SelectLbl')
		{
			this._onPauseClick();
			return;
		}

		if (actionId == 'Round')
		{
			if (currentEvents.find(e => !e.Answer && e.Action != 'CL'))
				return this.vibrate(gamepad);

			if (!isRed)
				return this.vibrate(gamepad);

			if (!this._RoundStarted)
				this.startRound();
			else
				this.nextRound();

			this.setRedStartState();
			this.setBlueStartState();
			return;
		}

		if (!this._RoundStarted)
		{
			return this.vibrate(gamepad);
		}


		if (isButtonHold)
		{
			if (!this._ButtonHoldProcessed)
			{
				this._ButtonHoldProcessed = true;
				// @ts-ignore
				if (isAnswer && ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8'].includes(actionId))
				{
					let knockdownEvent: IBattleEvent = {
						BattleId: this._Battle.Id,
						Round: this._Round,
						ActionAthleteId: isRed ? this._Battle.Red : this._Battle.Blue,
						AnswerAthleteId: isRed ? this._Battle.Blue : this._Battle.Red,
						Sequence: this._Sequence,
						Answer: 'Knockdown',
						Action: null,
						ActionTS: moment().utc().format('YYYY-MM-DD HH:mm:ss.S'),   //важно чтобы время на сервере и на клиенте совпадало
						Time: '00:' + this.getFormattedCurrentRoundTime()
					};

					currentEvents = this._events.filter(e => e.ActionAthleteId == (isRed ? this._Battle.Red : this._Battle.Blue));
					if (currentEvents.length > 0)
					{
						let lastEventWithAnswerIndex = currentEvents.findIndex(e => !e.Answer) - 1;
						if (lastEventWithAnswerIndex < 0)
							lastEventWithAnswerIndex = currentEvents.length - 1;

						knockdownEvent.Sequence = this._events[lastEventWithAnswerIndex].Sequence;
						this._events.splice(lastEventWithAnswerIndex + 1, 0, knockdownEvent);

						this.updateHistory();
					}
				}
			}
			return;
		}



		if (actionId == 'Space')
		{
			this._Sequence++;
			return;
		}


		if (this._LastEvDate == null)
			this._LastEvDate = new Date();
		else if ((new Date().getTime() - this._LastEvDate.getTime()) > 1500)
			this._Sequence++;

		this._LastEvDate = new Date();

		let ev: IBattleEvent;

		if (isAnswer)
		{
			ev = currentEvents.find(e => !e.Answer);
			if (!ev)
				return;
		}
		else
		{
			ev = {
				BattleId: this._Battle.Id,
				Round: this._Round,
				ActionAthleteId: isRed ? this._Battle.Red : this._Battle.Blue,
				AnswerAthleteId: isRed ? this._Battle.Blue : this._Battle.Red,
				Sequence: this._Sequence,
				Action: actionId,
				ActionTS: moment().utc().format('YYYY-MM-DD HH:mm:ss.S'),   //важно чтобы время на сервере и на клиенте совпадало
				Time: '00:' + this.getFormattedCurrentRoundTime()
			};
		}


		if (actionId == 'CL')
		{
			if (currentEvents.find(e => !e.Answer))
				return this.vibrate(gamepad);

			this._Sequence++;
			ev.Action = '_';
			ev.Answer = actionId;
			ev.ActionAthleteId = isRed ? this._Battle.Blue : this._Battle.Red;
			ev.AnswerAthleteId = isRed ? this._Battle.Red : this._Battle.Blue;
			if (isRed)
				this.setRedStartState();
			else
				this.setBlueStartState();

			this._events.push(ev);
			this.updateHistory();
		}
		else
		{
			if (isAnswer)
				ev.Answer = actionId;
			else
			{
				currentEvents.push(ev);
				this._events.push(ev);
				ev.Action = actionId;
			}

			if (currentEvents.find(e => !e.Answer))
			{
				if (isRed)
					this._leftPadLabels.forEach(lbl => lbl.setEnabled(true));
				else
					this._rightPadLabels.forEach(lbl => lbl.setEnabled(true));
			}
			else
			{
				if (isRed)
					this.setRedStartState();
				else
					this.setBlueStartState();
			}

			this.updateHistory();
		}

	}

	updateHistory()
	{
		this._historyLabel.setContent('');
		if (this._events.length)
		{
			let currentSequence = 1;
			// @ts-ignore
			for (let [index, ev] of this._events.entries())
			{
				if (ev.Round != this._Round)
					continue;
				let res = '',
					 historyRowClass = ev.ActionAthleteId == this._Battle.Red ? 'game-pad__history-row--red' : 'game-pad__history-row--blue';

				if (ev.Answer == 'Knockdown')
				{
					let knockdownNode = this._historyLabel.getRoot().lastChild as HTMLElement;
					if (this._events[index - 1])
					{
						if (this._events[index - 1].ActionAthleteId == this._Battle.Red)
							knockdownNode.innerText = knockdownNode.innerText + '•';
						else
							knockdownNode.innerText = '•' + knockdownNode.innerText;
					}
					continue;
				}

				if (currentSequence != ev.Sequence)
				{
					let space = NP.createNode(this._historyLabel.getRoot(), historyRowClass);
					space.innerText = '---' + NP.RM.getString('Space') + '---';
					this._historyLabel.setValue(currentSequence + 1);
					currentSequence++;
				}

				res += ev.ActionAthleteId == this._Battle.Red ? ev.Action : (ev.Answer || "_");
				res += '     ' + (ev.ActionAthleteId == this._Battle.Blue ? ev.Action : ev.Answer || "_");

				let span = NP.createNode(this._historyLabel.getRoot(), historyRowClass);
				span.innerText = res;

			}

			this._historyLabel.getRoot().scrollTop = this._historyLabel.getRoot().scrollHeight;
		}
	}

}